













































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'PoDialog',
})
export default class extends Vue {
  private dialog = false;

  private itemCode = '';

  private itemName = '';

  private itemDescription = '';

  private salesUnit = '';

  private subtotal = '';

  private onhand = '';

  private todayPo = '';

  public open(item: any) {
    this.dialog = true;
    this.itemCode = item.item_code;
    this.itemName = item.item_name;
    this.itemDescription = item.item_description;
    this.salesUnit = item.sales_unit;
    this.subtotal = typeof item.subtotal === 'number' ? item.subtotal.toFixed(2) : item.subtotal;
    this.onhand = typeof item.onhand === 'number' ? item.onhand.toFixed(2) : item.onhand;
    this.todayPo = typeof item.today_po === 'number' ? item.today_po.toFixed(2) : item.today_po;
  }
}
